export function Wordmark({ light = false, size = "text-xl" }) {
  return (
    <span className={`wordmark ${size} ${light ? "text-white" : ""}`} data-testid="brand-wordmark">
      CKing<span className="edu">Education</span>
    </span>
  );
}

const STYLES = {
  draft: "badge-draft",
  submitted: "badge-submitted",
  reviewed: "badge-reviewed",
  approved: "badge-approved",
  planned: "badge-neutral",
  completed: "badge-approved",
  not_sent: "badge-neutral",
  placeholder: "badge-neutral",
};

const LABELS = {
  draft: "Draft", submitted: "Submitted", reviewed: "Reviewed", approved: "Approved",
  planned: "Planned", completed: "Completed", not_sent: "Not sent", placeholder: "Placeholder",
};

export function StatusBadge({ status, prefix }) {
  return (
    <span className={STYLES[status] || "badge-neutral"} data-testid={`status-badge-${status}`}>
      {prefix}{LABELS[status] || status}
    </span>
  );
}

export function AgentDraftBadge() {
  return <span className="badge-draft" data-testid="status-badge-agent-draft">Agent Draft — unverified</span>;
}

export function PrivacyNotice() {
  return (
    <div className="notice-privacy" data-testid="privacy-notice">
      <span className="font-black shrink-0">!</span>
      <span>
        Do not enter identifiable student information in voice notes, logs, or external drafts unless
        specifically authorized by the district.
      </span>
    </div>
  );
}
